import type {QuestionStatus} from '@cp/model';
import {getCountFromServer, orderBy, query, where, type QueryConstraint} from 'firebase/firestore';
import getQuestionCollectionRef from './getQuestionCollectionRef';

export interface CountQuestionsByFiltersDocParams {
  moduleId: string;
  topics?: string[];
  difficulties?: number[];
  statuses?: QuestionStatus[];
}

const FIRESTORE_IN_MAX = 10;

export default async function countQuestionsByFiltersDoc(params: CountQuestionsByFiltersDocParams): Promise<number> {
  const {moduleId, topics, difficulties, statuses} = params;
  const col = getQuestionCollectionRef(moduleId);
  const constraints: QueryConstraint[] = [orderBy('createdAt', 'desc')];

  if (topics && topics.length > 0) {
    if (topics.length > FIRESTORE_IN_MAX) {
      throw new Error(`At most ${FIRESTORE_IN_MAX} topics supported per query`);
    }
    constraints.push(where('moduleTopic.topic', 'in', topics));
  }
  if (difficulties && difficulties.length > 0) {
    if (difficulties.length > FIRESTORE_IN_MAX) {
      throw new Error(`At most ${FIRESTORE_IN_MAX} difficulties supported per query`);
    }
    constraints.push(where('difficulty', 'in', difficulties));
  }
  if (statuses && statuses.length > 0) {
    if (statuses.length > FIRESTORE_IN_MAX) {
      throw new Error(`At most ${FIRESTORE_IN_MAX} statuses supported per query`);
    }
    constraints.push(where('status', 'in', statuses));
  }

  const agg = await getCountFromServer(query(col, ...constraints));
  return agg.data().count;
}
